import { render, staticRenderFns } from "./SideMenuBase.vue?vue&type=template&id=3b1c59fd&scoped=true&"
import script from "./SideMenuBase.vue?vue&type=script&lang=ts&"
export * from "./SideMenuBase.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuBase.vue?vue&type=style&index=0&id=3b1c59fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c59fd",
  null
  
)

export default component.exports